import { Impedimento, SectionVM } from 'civil-status/view-models/step-form';

export const transformerImpedimento = (
  dataSectionList?: Array<SectionVM>
): Array<Impedimento> | undefined => {
  if ((dataSectionList || []).length === 0) {
    return undefined;
  }

  return dataSectionList?.map((dataSection) => ({
    key: {
      idImpedimento: dataSection.idImpedimento || null,
    },
    idCertificato: dataSection.idCertificato || undefined,
    testoMotivazione: dataSection.reason || undefined,
    codiceSezione: dataSection.codeSection || undefined,
    sezione: dataSection.codeSection || undefined,
    tipoPersistenza: dataSection.typePersistence || undefined,
  }));
};
